import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InfoIconComponent, Label, RadioGroup, LabeledToggle, SettingsSeparator } from 'wix-rich-content-ui-components';
import cls from 'classnames';
import { M as MEMBER_ROLES, V as VISIBILITY_OPTIONS } from '../../../helpers-d59c72d9.js';
import { s as styleInject } from '../../../style-inject.es-746bb8ed.js';
import 'wix-rich-content-common/libs/imageUtils';

var css_248z = "[dir=ltr] .Tc0Z-{text-align:left}[dir=rtl] .Tc0Z-{text-align:right}[dir] .Kf4Cr{border-bottom:1px solid #ededed;padding:0 20px}.Kf4Cr .IE6bX{font-size:20px;line-height:1.4}[dir] .Kf4Cr .IE6bX{margin:25px 0 20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Kf4Cr{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .Kf4Cr{padding:20px}}}@container (width < 640px){.Kf4Cr{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .Kf4Cr{padding:20px}}.ZN9D3{height:auto;overflow:hidden}.ZN9D3,.xiDfS{align-items:center;display:flex}.xiDfS{flex-direction:row;font-family:inherit;font-size:16px;line-height:1;outline:none}[dir] .xiDfS{background:none;border:0;padding:0}.xiDfS.agU-7{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.xiDfS.Xei-c{color:inherit}.hstlO{box-sizing:border-box;height:calc(100% - 227px);overflow:scroll;position:absolute;top:127px;width:100%}[dir] .hstlO{padding:24px}.hstlO *,.hstlO :after,.hstlO :before{box-sizing:inherit}.hstlO input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.hstlO{height:calc(100% - 100px);top:100px}[dir] .hstlO{padding:20px}}}@container (width < 640px){.hstlO{height:calc(100% - 100px);top:100px}[dir] .hstlO{padding:20px}}.IE6bX{color:var(--ricos-settings-text-color,#000);font-size:16px;line-height:1.5}[dir] .IE6bX{margin:0 0 15px}.EafHb{color:var(--ricos-settings-text-color,#000);font-size:14px;line-height:1.43}[dir] .EafHb{margin:0 0 5px}.P7XOJ,._3iBZe,._5w1WQ{font-size:14px;line-height:1.43}[dir] .P7XOJ,[dir] ._3iBZe,[dir] ._5w1WQ{margin:0 0 5px}[dir] ._3iBZe{margin:10px 0}.-phTa{grid-column-gap:10px;grid-template-columns:repeat(3,1fr)}[dir] .-phTa{margin:10px 0}.dN8Kh{grid-column-gap:10px;grid-auto-rows:1fr;grid-template-columns:repeat(4,1fr)}[dir] .dN8Kh{margin:20px 0}@supports not (contain:inline-size){@media only screen and (max-width:640px){.dN8Kh{grid-template-columns:repeat(3,1fr)}}}@container (width < 640px){.dN8Kh{grid-template-columns:repeat(3,1fr)}}.ve5Ef{align-items:center;display:flex;flex-direction:row;gap:5px}[dir] .ve5Ef{margin:5px 0}.ve5Ef.BxUez{align-items:start;display:flex;flex-direction:column}[dir] .ve5Ef.BxUez{margin:10px 0 20px}.cU9Xu{align-items:center;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;height:auto}[dir] .cU9Xu{margin:0;padding-top:10px}[dir] .ETmWP{margin:5px 0}[dir] .cU9Xu:hover:not(.APR-J){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}[dir] .APR-J{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.APR-J *{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .lRKri{cursor:pointer;margin:15px 0;padding:0}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .lRKri{padding-top:0!important}}}@container (width < 640px){[dir] .lRKri{padding-top:0!important}}.LYpqK{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;justify-content:center;width:80%}[dir] .LYpqK{background:transparent}.i43dk{align-items:center;bottom:0;display:flex;flex-direction:column;justify-content:center;position:fixed;top:0;z-index:8}[dir] .i43dk{background-color:rgba(0,0,0,.6);cursor:auto}[dir=ltr] .i43dk,[dir=rtl] .i43dk{left:0;right:0}.wtLmn{display:flex;justify-content:flex-end;width:100%}[dir=ltr] .wtLmn{border-right:1px solid #ededed;padding-right:15px}[dir=rtl] .wtLmn{border-left:1px solid #ededed;padding-left:15px}._57QJJ{max-width:420px;position:absolute;top:77px;width:100%;z-index:2}[dir] ._57QJJ{background-color:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){._57QJJ{max-width:100%;top:50px}}}@container (width < 640px){._57QJJ{max-width:100%;top:50px}}.mPnRJ{top:unset}";
var styles = {"settings_container":"Tc0Z-","header":"Kf4Cr","title":"IE6bX","header_button_list":"ZN9D3","poll_header_button":"xiDfS","poll_header_button_primary":"agU-7","poll_header_button_secondary":"Xei-c","section":"hstlO","subtitle":"EafHb","sliderWithInput_label":"_3iBZe","label":"P7XOJ","checkbox_label":"_5w1WQ","preset_selector":"-phTa","layout_selector":"dN8Kh","radioGroup":"ve5Ef","radioPanel":"BxUez","selectionListOption":"cU9Xu","selectionListOptionLabel":"ETmWP","selectionListOption_selected":"APR-J","labeled_toggle_root":"lRKri","modal":"LYpqK","overlay":"i43dk","preview_button":"wtLmn","poll_tab_headers":"_57QJJ","Dropdown-menu":"mPnRJ"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PollSettingsSection extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "VOTE_ROLE_OPTIONS", [
      {
        value: MEMBER_ROLES.SITE_MEMBERS,
        labelText: this.props.t(
          "Poll_PollSettings_Tab_Settings_Section_Voting_Permission_SiteMember"
        )
      },
      {
        value: MEMBER_ROLES.ALL,
        labelText: this.props.t("Poll_PollSettings_Tab_Settings_Section_Voting_Permission_All")
      }
    ]);
    __publicField(this, "VIEW_ROLE_OPTIONS", [
      {
        value: VISIBILITY_OPTIONS.EVERYONE,
        labelText: /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.t("Poll_PollSettings_Tab_Settings_Section_Results_Permission_All"), "\xA0", /* @__PURE__ */ React.createElement(
          InfoIconComponent,
          {
            tooltipText: this.props.t(
              "Poll_PollSettings_Tab_Settings_Section_Results_Permission_All_Tooltip"
            )
          }
        ))
      },
      {
        value: VISIBILITY_OPTIONS.VOTERS,
        labelText: /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.t("Poll_PollSettings_Tab_Settings_Section_Results_Permission_Voters"), "\xA0", /* @__PURE__ */ React.createElement(
          InfoIconComponent,
          {
            tooltipText: this.props.t(
              "Poll_PollSettings_Tab_Settings_Section_Results_Permission_Voters_Tooltip"
            )
          }
        ))
      },
      {
        value: VISIBILITY_OPTIONS.CREATOR,
        labelText: /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.t("Poll_PollSettings_Tab_Settings_Section_Results_Permission_Owner"), "\xA0", /* @__PURE__ */ React.createElement(
          InfoIconComponent,
          {
            tooltipText: this.props.t(
              "Poll_PollSettings_Tab_Settings_Section_Results_Permission_Owner_Tooltip"
            )
          }
        ))
      }
    ]);
  }
  updatePermissions(permissions) {
    const { updateData, componentData } = this.props;
    updateData({
      poll: __spreadProps(__spreadValues({}, componentData.poll), {
        settings: __spreadProps(__spreadValues({}, componentData.poll.settings), {
          permissions: __spreadValues(__spreadValues({}, componentData.poll.settings.permissions), permissions)
        })
      })
    });
  }
  updateSettings(settings) {
    const { updateData, componentData } = this.props;
    updateData({
      poll: __spreadProps(__spreadValues({}, componentData.poll), {
        settings: __spreadValues(__spreadValues({}, componentData.poll.settings), settings)
      })
    });
  }
  render() {
    const { componentData, t, settings = {}, languageDir } = this.props;
    const {
      showVoters,
      showVotesCount,
      permissions: { view, vote, allowMultipleVotes }
    } = componentData.poll.settings;
    const { showVoteRoleSetting } = settings;
    return /* @__PURE__ */ React.createElement("section", { dir: languageDir, className: styles.section }, /* @__PURE__ */ React.createElement("p", { className: styles.title }, t("Poll_PollSettings_Tab_Settings_Section_Voting_Header")), showVoteRoleSetting && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Label, { label: t("Poll_PollSettings_Tab_Settings_Section_Voting_Permission_Title") }), /* @__PURE__ */ React.createElement(
      RadioGroup,
      {
        name: "voteRole",
        value: vote,
        onChange: (vote2) => this.updatePermissions({ vote: vote2 }),
        dataSource: this.VOTE_ROLE_OPTIONS,
        className: cls(styles.radioGroup, styles.radioPanel)
      }
    )), /* @__PURE__ */ React.createElement(
      LabeledToggle,
      {
        label: t("Poll_PollSettings_Tab_Settings_Section_Voting_Multiselect"),
        checked: allowMultipleVotes,
        onChange: () => this.updatePermissions({ allowMultipleVotes: !allowMultipleVotes })
      }
    ), /* @__PURE__ */ React.createElement(SettingsSeparator, { top: true, bottom: true }), /* @__PURE__ */ React.createElement("p", { className: styles.title }, t("Poll_PollSettings_Tab_Settings_Section_Results_Header")), /* @__PURE__ */ React.createElement(Label, { label: t("Poll_PollSettings_Tab_Settings_Section_Results_Permission_Title") }), /* @__PURE__ */ React.createElement(
      RadioGroup,
      {
        name: "resultsVisibility",
        value: view,
        onChange: (view2) => this.updatePermissions({ view: view2 }),
        dataSource: this.VIEW_ROLE_OPTIONS,
        className: cls(styles.radioGroup, styles.radioPanel)
      }
    ), view !== VISIBILITY_OPTIONS.CREATOR && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      LabeledToggle,
      {
        label: t("Poll_PollSettings_Tab_Settings_Section_Results_VoteVisibility"),
        checked: showVotesCount,
        onChange: () => this.updateSettings({
          showVoters: !showVotesCount,
          showVotesCount: !showVotesCount
        })
      }
    ), showVotesCount && /* @__PURE__ */ React.createElement(
      LabeledToggle,
      {
        label: t("Poll_PollSettings_Tab_Settings_Section_Results_VoterAnonymous"),
        checked: showVoters,
        onChange: () => this.updateSettings({ showVoters: !showVoters })
      }
    )));
  }
}
PollSettingsSection.propTypes = {
  componentData: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  experiments: PropTypes.object,
  languageDir: PropTypes.string
};

export { PollSettingsSection };
//# sourceMappingURL=PollSettingsSection.js.map
